import { updater } from "../../utils/updater.js";
import lightBoxContainer from "../../components/Structure/LightBoxManager/LightBoxContainer.js";

/**
 * Lightbox API factory.
 *
 */
export function lightBoxFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const closeLightBox = () => {
    updateState((draft) => {
      draft.fileType = null;
      draft.fileId = null;
      draft.isOpen = false;
    });
  };

  const setLightBox = (fileType, id, data) => {
    updateState((draft) => {
      draft.fileType = fileType;
      draft.fileId = id + "";
      draft.fileData = data || null;
      if (!draft.isOpen) draft.isOpen = true;
    });
  };

  const getLightBox = ({ ignoreUrl }) => {
    return state.fileType ? () => lightBoxContainer({ ignoreUrl }) : null;
  };

  const getFileId = () => state.fileId;
  const getFileType = () => state.fileType;
  const getFileData = () => state.fileData;
  const getCondition = () => state.isOpen;

  return {
    closeLightBox,
    setLightBox,
    getLightBox,
    getFileId,
    getFileType,
    getFileData,
    getCondition,
  };
}

export default lightBoxFactory;
